import { render, staticRenderFns } from "./AdStack.vue?vue&type=template&id=1a493fae&scoped=true"
import script from "./AdStack.vue?vue&type=script&lang=js"
export * from "./AdStack.vue?vue&type=script&lang=js"
import style0 from "./AdStack.vue?vue&type=style&index=0&id=1a493fae&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a493fae",
  null
  
)

export default component.exports